/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVersionUpdateRequest {
    getFixupPrototypeFunction() { return AppSecopsSbomVersionUpdateRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVersionUpdateRequest>): AppSecopsSbomVersionUpdateRequest {
        let obj = Object.assign(new AppSecopsSbomVersionUpdateRequest(), model);
        AppSecopsSbomVersionUpdateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVersionUpdateRequest>): AppSecopsSbomVersionUpdateRequest {
        if (!model) return null;
        return AppSecopsSbomVersionUpdateRequest.newInstance(<AppSecopsSbomVersionUpdateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVersionUpdateRequest) {
        if (!obj) return;

        models.AppSecopsSbomVersionUpdateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVersionUpdateRequest): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomVersionUpdateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Unique ID of the build associated with the SBOM version
     */
    build_id: string;

}
